module.exports = __webpack_public_path__ + "static/media/LOGO 2021.a8bf4ab9.png";